export const VIEW_APPLICATION_DISTRIBUTION_FETCHING =
  'VIEW_APPLICATION_DISTRIBUTION_FETCHING';
export const VIEW_APPLICATION_DISTRIBUTION_FETCHING_RESULTS =
  'VIEW_APPLICATION_DISTRIBUTION_FETCHING_RESULTS';
export const VIEW_APPLICATION_DISTRIBUTION_FETCH_ERROR =
  'VIEW_APPLICATION_DISTRIBUTION_FETCH_ERROR';
export const VIEW_APPLICATION_DISTRIBUTION_CLEAR_ERRORS =
  'VIEW_APPLICATION_DISTRIBUTION_CLEAR_ERRORS';
export const VIEW_APPLICATION_DISTRIBUTION_FETCH_SUCCESS =
  'VIEW_APPLICATION_DISTRIBUTION_FETCH_SUCCESS';
export const VIEW_APPLICATION_DISTRIBUTION_FETCH_RECORDS_SUCCESS =
  'VIEW_APPLICATION_DISTRIBUTION_FETCH_RECORDS_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/viewapplicationdistribution/state/types.js